import React, {useEffect, useMemo, useRef, useState} from 'react'
import styles from './EventNameTagsPage.module.css';
import {useParams} from "react-router";
import {AppBar, FormControl, Grid, InputLabel, Stack} from "@mui/material";
import axios from "axios";
import SelectInput from '../../components/common/inputs/SelectInput/SelectInput'
import HookForm from "../../components/common/HookForm";
import {useForm} from "react-hook-form";
import {useAutoEvt} from "../../queries/useAutoEvt";
import TextInput from "../../components/common/inputs/TextInput";
import {Button} from "@material-ui/core";
import download from 'downloadjs';
import LoadingBackdrop from "../../components/common/LoadingBackdrop";

interface Params {
  eventid: string
  guides: any
}

interface FormData {
    ticketid: number
    sizeid: number
    firstname: string,
    lastname: string,
    company: string,
    group: string,
    groupprefixtext: string,
    userdefined1: string,
    userdefinedprefixtext1: string,
    userdefined2: string,
    userdefinedprefixtext2: string,
    exportalltoexcel: string,
}

const EventNameTagsPage = () => {
    const { eventid, guides } = useParams<Params>()
    const { handleSubmit } = useForm()
    const formMethods = useForm()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { setValue, watch, getValues, setError, clearErrors, setFocus, reset } = formMethods

    useAutoEvt(eventid)
    const [tagsData, setTagsData] = React.useState({selectedticketid: null, selectedsizeid: null, sizelist: [], ticketlist: [], userdefinedlist: [], status: '', message: ''})

    const getTagsData = async () => {
        setIsLoading(true)
        var body = {'eventid': eventid}
        const { data } = await axios.post('/evtnametags', body)
        const parsedData = JSON.parse(data.jsonString)

        reset({
            ticketid: parsedData.selectedticketid,
            sizeid: parsedData.selectedsizeid
        })
        setTagsData(parsedData)
        setIsLoading(false)
    }

    useEffect(() => {
        getTagsData()
    }, [])

    const sizeList = tagsData && tagsData.sizelist ? tagsData.sizelist : []
    const sizeOptions = useMemo(
        () => sizeList.map((size) => {
            return { value: size.sizeid, label: size.sizename }
        }),
        [sizeList]
    )

    const ticketTypeList = tagsData && tagsData.ticketlist ? tagsData.ticketlist : []
    const ticketTypeOptions = useMemo(
        () => ticketTypeList.map((ticketType) => {
            return { value: ticketType.ticketid, label: ticketType.ticketname }
        }),
        [ticketTypeList]
    )

    const lineOptions = () => {
        return [
            { value: 'line1', label: 'Line 1' },
            { value: 'line2', label: 'Line 2' },
            { value: 'line3', label: 'Line 3' },
            { value: 'line4', label: 'Line 4' },
            { value: 'line5', label: 'Line 5' },
            { value: 'footer', label: 'Footer' },
            { value: 'notincluded', label: 'Not Included' },
        ]
    }


    const onSubmit = async (data: FormData) => {
        const body = {eventid: Number(eventid), ...data}
        console.log(body)
        axios.post(`evtnametagsprocess`, body).then(response => {})
    }

    const onSubmitExcel = async (data: FormData) => {
        setIsLoading(true)
        const formvalues = getValues()

        const userDefinedData = tagsData?.userdefinedlist.map((userData) => {
            return {
                userdefinedid: userData.userdefinedid,
                userdefinedvalue: formvalues['userdefined-' + userData.userdefinedid],
                userdefinedprefix: formvalues['userdefinedprefixtext-' + userData.userdefinedid]
            }
        })

        const body = {
            eventid: Number(eventid),
            groupvalue: formvalues['group'],
            groupprefix: formvalues['groupprefixtext'],
            company: formvalues['company'],
            firstname: formvalues['firstname'],
            lastname: formvalues['lastname'],
            sizeid: formvalues['sizeid'],
            ticketid: formvalues['ticketid'],
            type: 'exportalltoexcel',
            userdefineddata: userDefinedData
        }

        axios.post('/evtnametagsprocess', body, {responseType: "blob"}).then(response => {
            var filename = eventid + '-nametags.xlsx';
            var disposition = response.headers['content-disposition']
            var contentType = response.headers['content-type']
            if (disposition && disposition.indexOf('attachment') !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            if (response.data) {
                download(response.data, filename, contentType);
            }
            setIsLoading(false)
        })
    }

    const onSubmitPDF = async (data: FormData) => {
        setIsLoading(true)
        const formvalues = getValues()

        const userDefinedData = tagsData?.userdefinedlist.map((userData) => {
            return {
                userdefinedid: userData.userdefinedid,
                userdefinedvalue: formvalues['userdefined-' + userData.userdefinedid],
                userdefinedprefix: formvalues['userdefinedprefixtext-' + userData.userdefinedid]
            }
        })

        const body = {
            eventid: Number(eventid),
            groupvalue: formvalues['group'],
            groupprefix: formvalues['groupprefixtext'],
            company: formvalues['company'],
            firstname: formvalues['firstname'],
            lastname: formvalues['lastname'],
            sizeid: formvalues['sizeid'],
            ticketid: formvalues['ticketid'],
            type: 'exportpdf',
            userdefineddata: userDefinedData
        }

        axios.post('/evtnametagsprocess', body, {responseType: "blob"}).then(response => {
            var filename = eventid + '-nametags.pdf';
            var disposition = response.headers['content-disposition']
            var contentType = response.headers['content-type']
            if (disposition && disposition.indexOf('attachment') !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            if (response.data) {
                download(response.data, filename, contentType);
            }
            setIsLoading(false)
        })
    }

    const onSubmitWord = async (data: FormData) => {
        setIsLoading(true)
        const formvalues = getValues()

        const userDefinedData = tagsData?.userdefinedlist.map((userData) => {
            return {
                userdefinedid: userData.userdefinedid,
                userdefinedvalue: formvalues['userdefined-' + userData.userdefinedid],
                userdefinedprefix: formvalues['userdefinedprefixtext-' + userData.userdefinedid]
            }
        })

        const body = {
            eventid: Number(eventid),
            groupvalue: formvalues['group'],
            groupprefix: formvalues['groupprefixtext'],
            company: formvalues['company'],
            firstname: formvalues['firstname'],
            lastname: formvalues['lastname'],
            sizeid: formvalues['sizeid'],
            ticketid: formvalues['ticketid'],
            type: 'exportword',
            userdefineddata: userDefinedData
        }
        axios.post('/evtnametagsprocess', body, {responseType: "blob"}).then(response => {
            // console.log(response)
            // console.log(response.data)
            var filename = eventid + '-nametags.docx';
            var disposition = response.headers['content-disposition']
            var contentType = response.headers['content-type']
            if (disposition && disposition.indexOf('attachment') !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            if (response.data) {
                download(response.data, filename, contentType);
            }
            setIsLoading(false)
        })
    }

    return (
      <div className={styles.root}>
        <h1>Name Tags</h1>
          <LoadingBackdrop open={isLoading} />
          <HookForm
              methods={formMethods}
              onSubmit={onSubmit}
              className={styles.itemsForm}
              formProps={{ id: 'items-form' }}>
              <Grid container spacing={3}>
                  <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
                      <SelectInput
                          name={'ticketid'}
                          label={'Ticket Type'}
                          options={ticketTypeOptions}
                          includeNone={false}
                      />
                  </Grid>
                  <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
                      <SelectInput
                          name={'sizeid'}
                          label={'Name Tag Size'}
                          options={sizeOptions}
                          includeNone={false}
                      />
                  </Grid>
              </Grid>
              <Grid container spacing={0}>
                  <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
                      <h2>Build Your Name Tags</h2>
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                      <div>Assign your fields to specific lines or exclude them from the name tags</div>
                  </Grid>
                  <Grid item xs={6} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                      <SelectInput
                          name={'firstname'}
                          label={'First Name'}
                          options={lineOptions()}
                          includeNone={false}
                      />
                  </Grid>
                  <Grid item xs={6} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={6} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                      <SelectInput
                          name={'lastname'}
                          label={'Last Name'}
                          options={lineOptions()}
                          includeNone={false}
                      />
                  </Grid>
                  <Grid item xs={6} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={6} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                      <SelectInput
                          name={'company'}
                          label={'Company'}
                          options={lineOptions()}
                          includeNone={false}
                      />
                  </Grid>
                  <Grid item xs={6} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={6} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                      <SelectInput
                          name={'group'}
                          label={'Group'}
                          options={lineOptions()}
                          includeNone={false}
                      />
                  </Grid>
                  <Grid item xs={.5} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={5.5} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                      <TextInput
                          name="groupprefixtext"
                          label="Group Prefix Text"
                          tooltipText={''}
                      />
                  </Grid>
                  {tagsData?.userdefinedlist.map((userData) => {
                        return (
                            <>
                                <Grid item xs={6} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                                    <SelectInput
                                        name={'userdefined-' + userData.userdefinedid}
                                        label={userData.userdefinedname}
                                        options={lineOptions()}
                                        includeNone={false}
                                    />
                                </Grid>
                                <Grid item xs={.5} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                                </Grid>
                                <Grid item xs={5.5} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                                    <TextInput
                                        name={"userdefinedprefixtext-" + userData.userdefinedid}
                                        label={userData.userdefinedname + ' Prefix Text'}
                                        tooltipText={''}
                                    />
                                </Grid>
                            </>
                        )
                    })
                  }
              </Grid>
              <Grid container spacing={0}>
                  <Grid item xs={2.5} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Button onClick={handleSubmit(onSubmitWord)} name="generateword" type="submit" color="primary" variant="contained" className={styles.button}>
                          Generate Word
                      </Button>
                  </Grid>
                  <Grid item xs={.5} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={2.5} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Button onClick={handleSubmit(onSubmitPDF)} name="generatepdf" type="submit" color="primary" variant="contained" className={styles.button}>
                          Generate PDF
                      </Button>
                  </Grid>
                  <Grid item xs={.5} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={2.5} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Button onClick={handleSubmit(onSubmitExcel)} name="exportalltoexcel" type="submit" color="primary" variant="contained" className={styles.button}>
                          Export All Fields to Excel
                      </Button>
                  </Grid>
              </Grid>
          </HookForm>
      </div>
    )
}

export default EventNameTagsPage
